export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введення:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продовжити"])}
}